"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LogManager_1 = require("../../Log/LogManager");
const CommonBaseError_1 = require("../../Common/CommonBaseError");
class LocalMedia {
    constructor(icelink, doesProvideLocalVideo = false, doesProvideLocalAudio = false, doesProvidelocalScreenCapature = false) {
        this._logger = LogManager_1.logManager.GetLogger("LocalMedia");
        this.Audio = false;
        this.Video = false;
        this.LocalScreenCapture = false;
        //640x480, 320x240, 426x240, 640x360(not working properly)
        this.VideoWidth = 640; //160;
        this.VideoHeight = 480; //120;
        this.VideoFrameRate = 15;
        this.ScreenWidth = window.screen.width;
        this.ScreenHeight = window.screen.height;
        this.ScreenFrameRate = 3;
        if (!icelink)
            throw new LocalMediaError("No IceLink");
        this._icelink = icelink;
        this.Video = doesProvideLocalVideo;
        this.Audio = doesProvideLocalAudio;
        this.LocalScreenCapture = doesProvidelocalScreenCapature;
    }
    async StartAsync(videoContainer, localScreenWidth = -1, localScreenHeight = -1) {
        const localMedia = this;
        await new Promise((resolve, reject) => {
            const successCallback = (getMediaSuccessArgs //fm.icelink.webrtc.getMediaSuccessArgs
            ) => {
                localMedia.OnSuccessStartLocalMedia(videoContainer, getMediaSuccessArgs);
                this._logger.debug(`Start local sucessfully, with videoContainer=${videoContainer}`);
                resolve();
            };
            const errorCallback = (error) => {
                reject(error);
            };
            const mediaArgs = this.BuildGetMediaArgs(videoContainer, successCallback, errorCallback, localScreenWidth, localScreenHeight);
            this._logger.debug("Prepare to getMedia with: " + JSON.stringify(mediaArgs));
            this._icelink.webrtc.userMedia.getMedia(mediaArgs);
        });
    }
    /**
     * Build args for calling fm.icelink.webrtc.userMedia.getMedia
     *
     * @private
     * @param {object} videoContainer
     * @param {Action<fm.icelink.webrtc.getMediaSuccessArgs>} successCallback return fm.icelink.webrtc.getMediaSuccessArgs.
     * @param {Action<Error>} errorCallback return Error for further processing.
     * @param {number} [localScreenWidth=-1] Not used.
     * @param {number} [localScreenHeight=-1] Not used.
     * @returns {fm.icelink.webrtc.getMediaArgs}
     * @memberof LocalMedia
     */
    BuildGetMediaArgs(videoContainer, successCallback, errorCallback, localScreenWidth = -1, localScreenHeight = -1) {
        const localMedia = this;
        //consider to use marky
        // System.Diagnostics.Stopwatch sw = null;
        // if (_logger.IsDebugEnabled)
        // {
        //     sw = System.Diagnostics.Stopwatch.StartNew();
        // }
        const mediaArgs = {
            audio: localMedia.Audio,
            video: localMedia.Video,
            videoWidth: localMedia.VideoWidth,
            videoHeight: localMedia.VideoHeight,
            videoFrameRate: localMedia.VideoFrameRate,
            defaultVideoSource: this._icelink.webrtc.videoSource.Camera,
            defaultVideoPreviewScale: this._icelink.webrtc.layoutScale.Contain,
            defaultVideoScale: this._icelink.webrtc.layoutScale.Contain,
            onSuccess: (getMediaSuccessArgs) => {
                localMedia._logger.debug("Local media started succefully.");
                successCallback(getMediaSuccessArgs);
            },
            onFailure: (getMediaFailureArgs) => {
                const msg = `LocalMedia.Start: Could not get media. ${getMediaFailureArgs.getException().message}`;
                localMedia._logger.error(msg, getMediaFailureArgs.getException());
                errorCallback(getMediaFailureArgs.getException());
            },
            onComplete: (getMediaCompleteArgs) => {
                //consider to use marky
                //if (localMedia._logger.isDebugEnabled)
                //{
                // sw?.Stop();
                // _logger.Debug(() => $" {nameof(Start)} Takes {sw?.ElapsedMilliseconds} ms");
                //}
            }
        };
        if (this.LocalScreenCapture) {
            mediaArgs.videoWidth = localMedia.ScreenWidth;
            mediaArgs.videoHeight = localMedia.ScreenHeight;
            mediaArgs.videoFrameRate = localMedia.ScreenFrameRate;
            mediaArgs.defaultVideoSource = this._icelink.webrtc.videoSource.Screen;
        }
        else {
            if (!localMedia.Video) {
                //mediaArgs.VideoCaptureProvider = new NullVideoCaptureProvider();
                localMedia._logger.debug("Using NullVideoCaptureProvider");
            }
            if (!localMedia.Audio) {
                //mediaArgs.AudioCaptureProvider = new NullAudioCaptureProvider();
                localMedia._logger.debug("Using NullAudioCaptureProvider");
            }
        }
        return mediaArgs;
    }
    /**
     * Use fm.icelink.webrtc.getMediaSuccessArgs to initialize local video resource.
     *
     * @private
     * @param {object} videoContainer
     * @param {fm.icelink.webrtc.getMediaSuccessArgs} getMediaSuccessArgs
     * @memberof LocalMedia
     */
    OnSuccessStartLocalMedia(videoContainer, getMediaSuccessArgs) {
        const localMedia = this;
        // We have successfully acquired access to the local
        // audio/video device! Grab a reference to the media.
        // Internally, it maintains access to the local audio
        // and video feeds coming from the device hardware.
        localMedia.LocalMediaStream = getMediaSuccessArgs.getLocalStream();
        if (videoContainer != null && !this.LocalScreenCapture) {
            // This is our local video control, a DOM element
            // that displays video coming from the capture source.
            const localVideoControl = getMediaSuccessArgs.getLocalVideoControl();
            // Create an IceLink layout manager, which makes the task
            // of arranging video controls easy. Give it a reference
            // to a DOM element that can be filled with video feeds.
            localMedia.LayoutManager = new this._icelink.webrtc.layoutManager(videoContainer);
            // Display the local video control.
            localMedia.LayoutManager.setLocalVideoControl(localVideoControl);
        }
    }
    Stop(callback) {
        this._logger.debug("LocalMedia is stopping...");
        // Clear out the layout manager.
        if (this.LayoutManager) {
            this.LayoutManager.unsetLocalVideoControl();
            this.LayoutManager.removeRemoteVideoControls();
            this.LayoutManager = null;
        }
        // Stop the local media stream.
        if (this.LocalMediaStream) {
            this.LocalMediaStream.stop();
            this.LocalMediaStream = null;
        }
        callback(undefined);
        this._logger.debug("LocalMeida stopped");
    }
    Pause() {
        if (this.LocalMediaStream) {
            this.LocalMediaStream.pauseVideo();
            this.LocalMediaStream.pauseAudio();
        }
    }
    Resume() {
        if (this.LocalMediaStream) {
            this.LocalMediaStream.resumeVideo();
            this.LocalMediaStream.resumeAudio();
        }
    }
    // fm.icelink.webrtc.localMediaStream.getVideoDeviceNames/getAudioDeviceNames are not supported.
    DisplayAllDeviceNames() {
        const allVideoDeviceNames = this.LocalMediaStream.getVideoDeviceNames();
        for (let i = 0; i < allVideoDeviceNames.Length; i++) {
            this._logger.debug(`Video device Index=${i}, Name=${allVideoDeviceNames[i]}`);
        }
        const allAudioDeviceNames = this.LocalMediaStream.getAudioDeviceNames();
        for (let i = 0; i < allAudioDeviceNames.Length; i++) {
            this._logger.debug(`Audio device Index=${i}, Name=${allAudioDeviceNames[i]}`);
        }
    }
}
exports.LocalMedia = LocalMedia;
exports.LocalMediaErrorName = "LocalMediaError";
class LocalMediaError extends CommonBaseError_1.CommonBaseError {
}
exports.LocalMediaError = LocalMediaError;
//# sourceMappingURL=LocalMedia.js.map